(function () {
  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function hideFallbackPlaceholder(root) {
    var placeholder = root.querySelector('[data-video-placeholder]');

    if (placeholder) {
      placeholder.hidden = true;
    }
  }

  function primeFallbackPoster(root) {
    var image = root.querySelector('[data-video-fallback-poster]');

    if (!image || image.getAttribute('src')) {
      if (image) {
        image.hidden = false;
        hideFallbackPlaceholder(root);
      }
      return;
    }

    var provider = root.dataset.videoProvider;
    var originUrl = root.dataset.videoOriginUrl;

    if (provider !== 'vimeo' || !originUrl) {
      return;
    }

    fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(originUrl))
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Poster request failed');
        }

        return response.json();
      })
      .then(function (data) {
        if (!data || !data.thumbnail_url) {
          return;
        }

        image.src = data.thumbnail_url;
        image.hidden = false;
        hideFallbackPlaceholder(root);
      })
      .catch(function () {});
  }

  function activateExternal(root, shell) {
    if (shell.dataset.videoLoaded === 'true') {
      return;
    }

    var embedSrc = root.dataset.videoEmbedSrc;
    var title = root.dataset.videoTitle || 'Video player';

    if (!embedSrc) {
      return;
    }

    var iframe = document.createElement('iframe');
    iframe.src = embedSrc;
    iframe.className = 'mt-partner-video__player';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.setAttribute('title', title);

    shell.appendChild(iframe);
    shell.dataset.videoLoaded = 'true';
  }

  function activateUploaded(shell) {
    var video = shell.querySelector('video');

    if (!video) {
      return;
    }

    function attemptPlay() {
      try {
        video.currentTime = 0;
      } catch (error) {}

      try {
        var playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      } catch (error) {}
    }

    if (video.readyState >= 2) {
      attemptPlay();
      return;
    }

    var handleReady = function () {
      video.removeEventListener('loadedmetadata', handleReady);
      video.removeEventListener('loadeddata', handleReady);
      video.removeEventListener('canplay', handleReady);
      attemptPlay();
    };

    video.addEventListener('loadedmetadata', handleReady, { once: true });
    video.addEventListener('loadeddata', handleReady, { once: true });
    video.addEventListener('canplay', handleReady, { once: true });

    try {
      video.load();
    } catch (error) {}
  }

  function activateVideo(root, shell, mode) {
    shell.hidden = false;

    if (mode === 'external') {
      activateExternal(root, shell);
    } else if (mode === 'uploaded') {
      activateUploaded(shell);
    }

    root.classList.add('is-active');
  }

  function bindActivateTarget(target, root, shell, mode) {
    if (!target) {
      return;
    }

    target.addEventListener('click', function (event) {
      if (event.target && event.target.closest('[data-video-trigger]') && target !== event.target.closest('[data-video-trigger]')) {
        return;
      }

      activateVideo(root, shell, mode);
    });
  }

  function bindRoot(root) {
    if (!root || root.dataset.partnerVideoBound === 'true') {
      return;
    }

    primeFallbackPoster(root);

    var button = root.querySelector('[data-video-trigger]');
    var shell = root.querySelector('[data-video-player-shell]');
    var mode = root.dataset.videoMode;
    var poster = root.querySelector('[data-video-poster]');

    if (!button || !shell || mode === 'none') {
      root.dataset.partnerVideoBound = 'true';
      return;
    }

    bindActivateTarget(button, root, shell, mode);
    bindActivateTarget(poster, root, shell, mode);

    root.dataset.partnerVideoBound = 'true';
  }

  function initSection(section) {
    if (!section) {
      return;
    }

    var roots = section.querySelectorAll('[data-video-stage] [data-video-root]');

    roots.forEach(function (root) {
      bindRoot(root);
    });
  }

  function getActiveTemplateKey(section) {
    var hasDesktopTemplate = !!section.querySelector('[data-video-template="desktop"]');
    var hasMobileTemplate = !!section.querySelector('[data-video-template="mobile"]');

    if (mobileQuery.matches && hasMobileTemplate) {
      return 'mobile';
    }

    if (hasDesktopTemplate) {
      return 'desktop';
    }

    if (hasMobileTemplate) {
      return 'mobile';
    }

    return '';
  }

  function readTemplateHtml(template) {
    if (!template) {
      return '';
    }

    try {
      return JSON.parse(template.textContent);
    } catch (error) {
      return '';
    }
  }

  function renderActiveMedia(section) {
    if (!section) {
      return;
    }

    var stage = section.querySelector('[data-video-stage]');

    if (!stage) {
      initSection(section);
      return;
    }

    var activeKey = getActiveTemplateKey(section);

    if (!activeKey) {
      stage.innerHTML = '';
      stage.dataset.activeTemplate = '';
      return;
    }

    if (stage.dataset.activeTemplate !== activeKey) {
      var template = section.querySelector('[data-video-template="' + activeKey + '"]');

      if (!template) {
        return;
      }

      stage.innerHTML = readTemplateHtml(template);
      stage.dataset.activeTemplate = activeKey;
    }

    initSection(section);
  }

  function initAll(scope) {
    var sections = (scope || document).querySelectorAll('.mt-partner-video');

    sections.forEach(function (section) {
      renderActiveMedia(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', function () {
      initAll(document);
    });
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(function () {
      initAll(document);
    });
  }
})();
